module.exports = __webpack_public_path__ + "static/chartering-staticLR-d802193061831761bd1e0476106bdcd4.jpg";